export function initializeAnchors(){
	const anchorLinks = document.querySelectorAll('.anchorLinks');

	anchorLinks.forEach((parent) => {
		const anchorContainer = parent.querySelector('.anchor-links__items');
		anchorContainer.dataset.animation = true;	
	})	
}